<template>
  <header class="header-bg">
    <div class="header-bg-gradient d-flex justify-content-between pl-2 pr-2">
      <div class="w-25">
        <router-link to="/">
          <img alt="logo app" src="../../assets/logo.png" class="img-fluid">
        </router-link>
      </div>
      <div class="align-self-center d-flex">
        <div class="d-flex" v-if="auth">
          <router-link to="/" class="button-inactive" active-class="button-active" exact>
            <button type="button" class="btn btn-sm mr-2 text-color-blue">
              <span class="">Dashboard</span>
            </button>
          </router-link>
          <div class="separator mr-2"></div>
        </div>
        <div class="d-flex" v-if="!auth">
          <router-link to="/login" class="button-inactive" active-class="button-active" exact>
            <button type="button" class="btn btn-sm mr-2 text-color-blue">
              <span class="">Sign-In</span>
            </button>
          </router-link>
        </div>
        <div class="d-flex" v-if="!auth">
          <div class="separator mr-2"></div>
          <router-link to="register" class="button-inactive" active-class="button-active">
            <button type="button" class="btn btn-sm mr-2 text-color-blue">
              <span>Sign-Up</span>
            </button>
          </router-link>
          <div v-if="auth" class="separator mr-2"></div>
        </div>
        <div class="d-flex" v-if="auth">
          <router-link to="updateprofile" class="button-inactive" active-class="button-active">
            <button type="button" class="btn btn-sm mr-2 size-button rounded-circle">
              <font-awesome-icon icon="user"/>
            </button>
          </router-link>
        </div>
        <div class="d-flex">
          <div class="separator mr-2"></div>
          <router-link to="help" class="button-inactive" active-class="button-active">
            <button type="button" class="btn btn-sm size-button rounded-circle">
              <span class="">?</span>
            </button>
          </router-link>
        </div>
        <div class="d-flex" v-if="auth">
          <div class="separator ml-2 mr-2"></div>
          <a class="button-inactive">
            <button @click="onLogout" type="button" class="btn btn-sm mr-2 text-color-blue">
              <font-awesome-icon icon="sign-out-alt"/>
            </button>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  computed: {
    auth () {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('sign_out')
        .then(() => console.log('Log out successfully !'))
        .catch(() => console.log('Failed to log out !'))
    }
  }
}
</script>

<style scoped>
  .header-bg{
    background-color: rgba(1, 142, 167, 0.5);
  }
  .button-inactive > button{
    background-color: var(--color-light-white);
    color: var(--color-blue);
    border: 1px solid var(--color-blue);
  }
  .button-active > button, button:hover{
    background-color: var(--color-blue);
    color: var(--color-white);
    border: 1px solid var(--color-blue);
  }
  .size-button{
    width: 30px;
    height: 30px;
  }
  .header-bg-gradient{
    background-image: linear-gradient( 180deg, rgb(244,247,248) 47%, rgba(244,247,248,0.32) 83%, rgba(1,142,167,0) 100%, rgba(1,142,167,0) 100%);
    background-image: -moz-linear-gradient( 180deg, rgb(244,247,248) 47%, rgba(244,247,248,0.32) 83%, rgba(1,142,167,0) 100%, rgba(1,142,167,0) 100%);
    background-image: -webkit-linear-gradient( 180deg, rgb(244,247,248) 47%, rgba(244,247,248,0.32) 83%, rgba(1,142,167,0) 100%, rgba(1,142,167,0) 100%);
    background-image: -ms-linear-gradient( 180deg, rgb(244,247,248) 47%, rgba(244,247,248,0.32) 83%, rgba(1,142,167,0) 100%, rgba(1,142,167,0) 100%);
    background-image: -o-linear-gradient( 180deg, rgb(244,247,248) 47%, rgba(244,247,248,0.32) 83%, rgba(1,142,167,0) 100%, rgba(1,142,167,0) 100%);
  }
  .separator{
    width: 3px;
    height: 30px;
    background-color: var(--color-blue);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue